import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import { Breakpoints } from '../constants';
import breakpoint from '../mixins/breakpoint';

const hideStyle = css`display: none;`;

const ShowFor = styled.div`
    ${p => !p.xxsmall && css`${breakpoint('xxsmall', { only: true })} {${hideStyle}}`}
    ${p => !p.xsmall && css`${breakpoint('xsmall', { only: true })} {${hideStyle}}`}
    ${p => !p.small && css`${breakpoint('small', { only: true })} {${hideStyle}}`}
    ${p => !p.medium && css`${breakpoint('medium', { only: true })} {${hideStyle}}`}
    ${p => !p.large && css`${breakpoint('large', { only: true })} {${hideStyle}}`}
    ${p => !p.xlarge && css`${breakpoint('xlarge', { only: true })} {${hideStyle}}`}
    ${p => !p.xxlarge && css`${breakpoint('xxlarge', { only: true })} {${hideStyle}}`}
`;

ShowFor.propTypes = Object
    .keys(Breakpoints)
    .reduce((props, key) => {
        return {
            ...props,
            [key]: PropTypes.bool,
        };
    }, {});

export default ShowFor;
